<!--
  ~ `standalone: true` is required: this component is itself a ControlValueAccessor, so without it
  ~ the inner ngModel finds an ancestor formGroup and Angular throws when the group is used with
  ~ formControlName.
  -->
<mat-radio-group
  [(ngModel)]="value"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="onSelectionChange($event)"
  [disabled]="disabled"
  [color]="color"
  (blur)="onBlur()"
>
  <div *ngFor="let option of options">
    <mat-radio-button [value]="option.value" [color]="color" [name]="name" [disabled]="option.disabled || disabled">
      <span class="small">{{ option.label }}</span>
    </mat-radio-button>
  </div>
</mat-radio-group>
